export default class WooCommercePrices {
  constructor() {
    this.dom = {}
    this.getDomElements()

    if (!this.dom.variants || !this.dom.visiblePriceElement) return

    this.init()
  }

  init() {
    this.price = this.dom.visiblePriceElement.innerHTML
    this.cachedPrice = this.dom.visiblePriceElement.innerHTML
    this.handler()
  }

  getDomElements() {
    this.dom = {
      variants: document.querySelectorAll('.variations_form select'),
      visiblePriceElement: document.querySelector('p.price'),
      hiddenPriceElement: document.querySelector('.woocommerce-variation.single_variation')
    }
  }

  handler() {
    this.dom.variants.forEach(select => {
      select.addEventListener('change', () => {
        setTimeout(() => {
          let priceField = this.dom.hiddenPriceElement.querySelector('.woocommerce-variation-price')

          if (select.value && priceField && priceField.innerHTML) {
            this.price = priceField.innerHTML
          } else {
            this.price = this.cachedPrice
          }

          this.setPrice()
        }, 0)
      })
    })
  }

  setPrice() {
    this.dom.visiblePriceElement.innerHTML = this.price
  }
}